import { IState } from '../../store';
import { pathOr } from 'ramda';

export const getNewbuildingName = (state: IState) => {
  return pathOr(null, ['offerData', 'newObject', 'name'], state);
};
